export default __webpack_public_path__ + "static/media/a6.fc6ba0b4.JPG";